"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouterContext = exports.RouterContextProvider = exports.useRouterProviderProps = exports.useRouter = exports.useRouteMatch = exports.MemoryRouterComponent = exports.BrowserRouterComponent = exports.RouterComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Router_1 = require("@reactionable/core/lib/router/Router");
const react_router_dom_1 = require("react-router-dom");
const Route_1 = require("../route/Route");
const RouterLink_1 = require("./RouterLink");
function RouterComponent({ children, routes, HomeComponent, NotFoundComponent, }) {
    const routesToRender = routes || [];
    if (HomeComponent) {
        const hasHomeRoute = routesToRender.some(({ path }) => path === "/");
        if (!hasHomeRoute) {
            routesToRender.unshift({
                component: HomeComponent,
                exact: true,
                path: "/",
                privateRoute: false,
            });
        }
    }
    if (NotFoundComponent) {
        const hasNotFoundRoute = routesToRender.some(({ path }) => path === undefined);
        if (!hasNotFoundRoute) {
            routesToRender.push({ component: NotFoundComponent, privateRoute: false });
        }
    }
    if (routesToRender.length) {
        children = Route_1.renderRoutes(routesToRender);
    }
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
}
exports.RouterComponent = RouterComponent;
function BrowserRouterComponent(props) {
    return (jsx_runtime_1.jsx(react_router_dom_1.BrowserRouter, { children: jsx_runtime_1.jsx(RouterComponent, Object.assign({}, props), void 0) }, void 0));
}
exports.BrowserRouterComponent = BrowserRouterComponent;
function MemoryRouterComponent(props) {
    return (jsx_runtime_1.jsx(react_router_dom_1.MemoryRouter, { children: jsx_runtime_1.jsx(RouterComponent, Object.assign({}, props), void 0) }, void 0));
}
exports.MemoryRouterComponent = MemoryRouterComponent;
function useRouteMatch() {
    return react_router_dom_1.useRouteMatch();
}
exports.useRouteMatch = useRouteMatch;
function useRouter() {
    const match = useRouteMatch();
    const history = react_router_dom_1.useHistory();
    return {
        match,
        push: history.push.bind(history),
    };
}
exports.useRouter = useRouter;
const useRouterProviderProps = (props = {}) => {
    return Object.assign(Object.assign(Object.assign({}, Router_1.useRouterProviderProps()), { Component: BrowserRouterComponent, RouterLink: RouterLink_1.RouterLink, useRouteMatch, renderRoutes: Route_1.renderRoutes }), props);
};
exports.useRouterProviderProps = useRouterProviderProps;
const RouterContextProvider = (props) => {
    return (jsx_runtime_1.jsx(Router_1.RouterContextProvider, Object.assign({}, exports.useRouterProviderProps(props)), void 0));
};
exports.RouterContextProvider = RouterContextProvider;
function useRouterContext() {
    return Router_1.useRouterContext();
}
exports.useRouterContext = useRouterContext;
//# sourceMappingURL=Router.js.map